import {useLocation, useParams} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {EditLocalStoragePagesData} from "../../../../../utils/EditLocalStoragePagesData";
import UtilityService from "../../../../../API/common/UtilityService";
import {constantsErrorMessages} from "../../../../../Constants";
import {Box} from "@mui/system";
import {BreadcrumbsComponent} from "../../../../../components/UI/breadcrumb/BreadcrumbComponent";
import Typography from "@mui/material/Typography";
import WarehouseMaterialItemTable
    from "../../../../../components/UI/table/warehouse/material/materialwarehouse/WarehouseMaterialItemTable";
import MaterialWarehouseService from "../../../../../API/orders/warehouse/material/MaterialWarehouseService";
import ModalAlert from "../../../../../components/UI/table/customer-detales/ModalAlert";

const MaterialWarehouseChildren = () => {
    const pathname = useLocation().pathname
    const [currencies, setCurrencies] = useState()
    const [currencyMap, setCurrencyMap] = useState(new Map);
    const [alertData, setAlertData] = useState({});
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })

    const params = useParams();
    const id = params.id;
    const baseUnit = params.baseUnit;
    const typeMaterial = params.typeMaterial;
    const materialId = params.materialId;
    const nameMaterial = params.nameMaterial;
    const childrenId = params.childrenId

    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }

    useEffect(() => {
        UtilityService.getCurrencies()
            .then(function (response) {
                const data = response.data;
                data.forEach((c) => {
                    currencyMap.set(c.id, c);
                });
                setCurrencies(data)
            }).catch(function (error) {
            handleModalAlert(error)
        })
    }, []);

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={"В обрезках"}
                path={[
                    {name: "Главная", href: "/"},
                    {name: "Материалы", href: "/organization/materials"},
                    {
                        name: nameMaterial,
                        href: `/organization/materials/${id}/${baseUnit}/${typeMaterial}/${materialId}`
                    },
                ]}/>
            <Box sx={{display: "flex", flexDirection: "column"}}>
                <Box sx={{display: "flex", flexDirection: "column"}}>
                    <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                        {nameMaterial}
                    </Typography>
                </Box>
                <WarehouseMaterialItemTable
                    getAll={MaterialWarehouseService.getAllByMaterialIdChildren}
                    id={id}
                    materialId={materialId}
                    baseUnit={baseUnit}
                    typeMaterial={typeMaterial}
                    currencyMap={currencyMap}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    currencies={currencies}
                    handleModalAlert={handleModalAlert}
                    childrenId={childrenId}
                    material={{
                        name: nameMaterial,
                }}
                />
                <ModalAlert
                    data={alertData}
                    onClose={() => setAlertData((alert) => ({...alert, open: false}))}
                />
            </Box>
        </Box>
    );
};

export default MaterialWarehouseChildren;